module.exports = __webpack_public_path__ + "3d33e7964b78103b63c7af9a174f1274.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ss-glyphish-outlined.woff
// module id = 353
// module chunks = 0